<template>
  <title-card title="Files Submitted For This Loan" >
    <filter-table
      primary-key="id"
      empty-text="No Documents added."
      :fields="fields"
      :items="getDocuments"
      :slots="templates"
      :stickyHeader="true"
      :show-filter="false"
    >
      <template slot="name" slot-scope="record">
        <a :href="record.row.item.link" target="_blank" class="no-text-decoration">
          {{ record.value }}
        </a>
      </template>
      <template slot="submitted" slot-scope="record">
        {{record.value | date}}
      </template>
    </filter-table>
  </title-card>
</template>

<script>
import TitleCard from '@/components/utils/TitleCard';
import DocumentsLegend from '@/components/utils/DocumentsLegend';
import FilterTable from '@/components/utils/FilterTable';

export default {
  name: 'FilesSubmited',
  components: {
    DocumentsLegend,
    TitleCard,
    FilterTable,
  },
  props: {
    loan: Object,
  },
  data() {
    return {
      modalRecord: {},
      documents: [],
      fields: [
        { key: 'name', sortable: true },
        { key: 'submitted', sortable: true },
      ],
      templates: [
        { key: 'name' },
        { key: 'submitted' },
      ],
    };
  },
  mounted() {
    this.documents = this.getDocuments;
  },
  computed: {
    getDocuments() {
      const documents = [];

      if (this.loan.documents) {
        const assetManagement = this.filterAssetManagement(this.loan.documents.asset_management);
        const standard = this.filterStandardDocuments(this.loan.documents.standard);

        if (standard) documents.push(...standard);
        if (assetManagement) documents.push(...assetManagement);

        documents.push(...this.loan.documents.salesforce);
      }
      return documents.sort((a, b) => new Date(b.submitted) - new Date(a.submitted));
    },
  },
  methods: {
    filterStandardDocuments: (documents) => {
      const newListDocuments = [];
      const filteredDocuments = documents.filter(document => document.type !== 'salesforce');

      Object.keys(filteredDocuments).forEach((item) => {
        if (documents[item].files.length > 0) {
          newListDocuments.push(...documents[item].files);
        }
      });

      return newListDocuments;
    },
    filterAssetManagement: (documents) => {
      const newListDocuments = [];
      Object.keys(documents).forEach((item) => {
        if (documents[item].length > 0) {
          newListDocuments.push(...documents[item]);
        }
      });
      return newListDocuments;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/deals/documents/FilesSubmited.vue